import { c as _c } from "react/compiler-runtime";
import { Form, type TemplateInputProps } from '@onefootprint/ui';
import { useFormContext, useWatch } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { useAutoDataIdentifier } from '../../../hooks/use-auto-data-identifier';
import type { CustomQuestionsFormData, NumberFormatKind } from '../../../types';
import DataIdentifierField from '../data-identifier-field';
type NumberFormProps = {
  questionIndex: number;
  autocompleteItems?: TemplateInputProps['autocompleteItems'];
};
const NumberForm = t0 => {
  const $ = _c(88);
  const {
    questionIndex,
    autocompleteItems
  } = t0;
  const {
    t
  } = useTranslation("playbook-custom-questions");
  const {
    control
  } = useFormContext();
  const t1 = `questions.${questionIndex}.numberFormat`;
  let t2;
  if ($[0] !== control || $[1] !== t1) {
    t2 = {
      control,
      name: t1
    };
    $[0] = control;
    $[1] = t1;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  const numberFormat = useWatch(t2) as NumberFormatKind;
  useAutoDataIdentifier(questionIndex);
  const t3 = `questions.${questionIndex}.label`;
  let t4;
  if ($[3] !== t) {
    t4 = t(_temp);
    $[3] = t;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  let t5;
  if ($[5] !== t) {
    t5 = t(_temp2);
    $[5] = t;
    $[6] = t5;
  } else {
    t5 = $[6];
  }
  let t6;
  if ($[7] !== autocompleteItems) {
    t6 = autocompleteItems ?? {};
    $[7] = autocompleteItems;
    $[8] = t6;
  } else {
    t6 = $[8];
  }
  let t7;
  if ($[9] !== t3 || $[10] !== t4 || $[11] !== t5 || $[12] !== t6) {
    t7 = <Form.TemplateInput name={t3} label={t4} placeholder={t5} size="compact" autocompleteItems={t6} />;
    $[9] = t3;
    $[10] = t4;
    $[11] = t5;
    $[12] = t6;
    $[13] = t7;
  } else {
    t7 = $[13];
  }
  const t8 = `questions.${questionIndex}.numberFormat`;
  let t9;
  if ($[14] !== t) {
    t9 = t(_temp3);
    $[14] = t;
    $[15] = t9;
  } else {
    t9 = $[15];
  }
  let t10;
  if ($[16] !== t) {
    t10 = t(_temp4);
    $[16] = t;
    $[17] = t10;
  } else {
    t10 = $[17];
  }
  let t11;
  if ($[18] !== t10) {
    t11 = {
      value: "any",
      label: t10
    };
    $[18] = t10;
    $[19] = t11;
  } else {
    t11 = $[19];
  }
  let t12;
  if ($[20] !== t) {
    t12 = t(_temp5);
    $[20] = t;
    $[21] = t12;
  } else {
    t12 = $[21];
  }
  let t13;
  if ($[22] !== t12) {
    t13 = {
      value: "currency",
      label: t12
    };
    $[22] = t12;
    $[23] = t13;
  } else {
    t13 = $[23];
  }
  let t14;
  if ($[24] !== t11 || $[25] !== t13) {
    t14 = [t11, t13];
    $[24] = t11;
    $[25] = t13;
    $[26] = t14;
  } else {
    t14 = $[26];
  }
  let t15;
  if ($[27] !== t14 || $[28] !== t8 || $[29] !== t9) {
    t15 = <Form.Select name={t8} label={t9} options={t14} size="compact" />;
    $[27] = t14;
    $[28] = t8;
    $[29] = t9;
    $[30] = t15;
  } else {
    t15 = $[30];
  }
  let t16;
  if ($[31] !== numberFormat || $[32] !== questionIndex || $[33] !== t) {
    t16 = numberFormat === "currency" && <Form.Select name={`questions.${questionIndex}.currencyCode`} label={t(_temp6)} options={[{
      value: "usd",
      label: "USD ($)"
    }]} size="compact" />;
    $[31] = numberFormat;
    $[32] = questionIndex;
    $[33] = t;
    $[34] = t16;
  } else {
    t16 = $[34];
  }
  const t17 = `questions.${questionIndex}.min`;
  let t18;
  if ($[35] !== t) {
    t18 = t(_temp7);
    $[35] = t;
    $[36] = t18;
  } else {
    t18 = $[36];
  }
  let t19;
  if ($[37] !== t) {
    t19 = t(_temp8);
    $[37] = t;
    $[38] = t19;
  } else {
    t19 = $[38];
  }
  let t20;
  if ($[39] !== t17 || $[40] !== t18 || $[41] !== t19) {
    t20 = <Form.Number name={t17} label={t18} placeholder={t19} size="compact" containerClassName="flex-1" />;
    $[39] = t17;
    $[40] = t18;
    $[41] = t19;
    $[42] = t20;
  } else {
    t20 = $[42];
  }
  const t21 = `questions.${questionIndex}.max`;
  let t22;
  if ($[43] !== t) {
    t22 = t(_temp9);
    $[43] = t;
    $[44] = t22;
  } else {
    t22 = $[44];
  }
  let t23;
  if ($[45] !== t) {
    t23 = t(_temp10);
    $[45] = t;
    $[46] = t23;
  } else {
    t23 = $[46];
  }
  let t24;
  if ($[47] !== t21 || $[48] !== t22 || $[49] !== t23) {
    t24 = <Form.Number name={t21} label={t22} placeholder={t23} size="compact" containerClassName="flex-1" />;
    $[47] = t21;
    $[48] = t22;
    $[49] = t23;
    $[50] = t24;
  } else {
    t24 = $[50];
  }
  let t25;
  if ($[51] !== t20 || $[52] !== t24) {
    t25 = <div className="flex gap-3">{t20}{t24}</div>;
    $[51] = t20;
    $[52] = t24;
    $[53] = t25;
  } else {
    t25 = $[53];
  }
  const t26 = `questions.${questionIndex}.placeholder`;
  let t27;
  if ($[54] !== t) {
    t27 = t(_temp11);
    $[54] = t;
    $[55] = t27;
  } else {
    t27 = $[55];
  }
  let t28;
  if ($[56] !== t) {
    t28 = t(_temp12);
    $[56] = t;
    $[57] = t28;
  } else {
    t28 = $[57];
  }
  let t29;
  if ($[58] !== t26 || $[59] !== t27 || $[60] !== t28) {
    t29 = <Form.Input name={t26} label={t27} placeholder={t28} size="compact" />;
    $[58] = t26;
    $[59] = t27;
    $[60] = t28;
    $[61] = t29;
  } else {
    t29 = $[61];
  }
  let t30;
  if ($[62] !== t) {
    t30 = t(_temp13);
    $[62] = t;
    $[63] = t30;
  } else {
    t30 = $[63];
  }
  let t31;
  if ($[64] !== t) {
    t31 = t(_temp14);
    $[64] = t;
    $[65] = t31;
  } else {
    t31 = $[65];
  }
  let t32;
  if ($[66] !== t) {
    t32 = t(_temp15);
    $[66] = t;
    $[67] = t32;
  } else {
    t32 = $[67];
  }
  let t33;
  if ($[68] !== t32) {
    t33 = {
      text: t32
    };
    $[68] = t32;
    $[69] = t33;
  } else {
    t33 = $[69];
  }
  let t34;
  if ($[70] !== questionIndex || $[71] !== t30 || $[72] !== t31 || $[73] !== t33) {
    t34 = <DataIdentifierField questionIndex={questionIndex} label={t30} placeholder={t31} tooltip={t33} />;
    $[70] = questionIndex;
    $[71] = t30;
    $[72] = t31;
    $[73] = t33;
    $[74] = t34;
  } else {
    t34 = $[74];
  }
  const t35 = `questions.${questionIndex}.required`;
  let t36;
  if ($[75] !== t) {
    t36 = t(_temp16);
    $[75] = t;
    $[76] = t36;
  } else {
    t36 = $[76];
  }
  let t37;
  if ($[77] !== t35 || $[78] !== t36) {
    t37 = <Form.Toggle name={t35} label={t36} size="compact" />;
    $[77] = t35;
    $[78] = t36;
    $[79] = t37;
  } else {
    t37 = $[79];
  }
  let t38;
  if ($[80] !== t15 || $[81] !== t16 || $[82] !== t25 || $[83] !== t29 || $[84] !== t34 || $[85] !== t37 || $[86] !== t7) {
    t38 = <div className="flex flex-col gap-6">{t7}{t15}{t16}{t25}{t29}{t34}{t37}</div>;
    $[80] = t15;
    $[81] = t16;
    $[82] = t25;
    $[83] = t29;
    $[84] = t34;
    $[85] = t37;
    $[86] = t7;
    $[87] = t38;
  } else {
    t38 = $[87];
  }
  return t38;
};
export default NumberForm;
function _temp($) {
  return $.form.label;
}
function _temp2($_0) {
  return $_0.form.labelPlaceholder;
}
function _temp3($_1) {
  return $_1.form.numberFormat;
}
function _temp4($_2) {
  return $_2.numberFormats.any;
}
function _temp5($_3) {
  return $_3.numberFormats.currency;
}
function _temp6($_4) {
  return $_4.form.currencyCode;
}
function _temp7($_5) {
  return $_5.form.min;
}
function _temp8($_6) {
  return $_6.form.minPlaceholder;
}
function _temp9($_7) {
  return $_7.form.max;
}
function _temp10($_8) {
  return $_8.form.maxPlaceholder;
}
function _temp11($_9) {
  return $_9.form.placeholder;
}
function _temp12($_10) {
  return $_10.form.placeholderPlaceholder;
}
function _temp13($_11) {
  return $_11.form.dataIdentifier;
}
function _temp14($_12) {
  return $_12.form.dataIdentifierPlaceholder;
}
function _temp15($_13) {
  return $_13.form.dataIdentifierTooltip;
}
function _temp16($_14) {
  return $_14.form.required;
}